import {
  Button,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { usePayoffRequestStore } from '../hooks/usePayoffRequestStore';
import { useBaseStore } from '@roc/feature-app-core';
import { RequestPayoffDialog } from './requestPayoffDialog';

export const RequestPayoffButton = observer(() => {

  const { payoffRequestStore, payoffRequestStore: { disableCreatePayoff } } = usePayoffRequestStore();
  const { globalStore } = useBaseStore();

  const handleRequestPayoff = () => {
    if (!payoffRequestStore.currentPayoff) {
      payoffRequestStore.setIsNewPayoffRequestModalOpen(true);
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'There is an active payoff for this loan.',
      });
    }
  };

  return (
    <>
      <Button
        testId="requestPayoff"
        variant="contained"
        size="small"
        color="primary"
        disabled={disableCreatePayoff}
        onClick={handleRequestPayoff}
      >
        Request Payoff
      </Button>
      <RequestPayoffDialog />
    </>
  );
});